import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import { AuthProvider, ProtectedRoute } from "./context/AuthContext";
import { SeoProvider } from "./lib/seo";

const ServiceDetail = lazy(() => import("./pages/ServiceDetail"));
const ServicesIndex = lazy(() => import("./pages/ServiceDetail").then((m) => ({ default: m.ServicesIndex })));
const Configurator = lazy(() => import("./pages/Configurator"));
const Besichtigung = lazy(() => import("./pages/Besichtigung"));
const Einsatzgebiete = lazy(() => import("./pages/Einsatzgebiete"));
const OrtPage = lazy(() => import("./pages/OrtPage"));
const LeistungOrt = lazy(() => import("./pages/LeistungOrt"));
const Kontakt = lazy(() => import("./pages/Static").then((m) => ({ default: m.Kontakt })));
const Impressum = lazy(() => import("./pages/Static").then((m) => ({ default: m.Impressum })));
const Datenschutz = lazy(() => import("./pages/Static").then((m) => ({ default: m.Datenschutz })));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/Admin"));
const NotFound = lazy(() => import("./pages/NotFound"));

const Loading = () => <div className="min-h-[60vh]" aria-hidden="true" />;

const Site = ({ children, light }) => (
  <Layout>
    <div className={light ? "nx-light" : ""}>
      <Suspense fallback={<Loading />}>{children}</Suspense>
    </div>
  </Layout>
);

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SeoProvider>
        <ScrollTop />
        <Toaster theme="light" position="top-right" />
        <Routes>
          <Route path="/" element={<Site><Home /></Site>} />
          <Route path="/leistungen" element={<Site light><ServicesIndex /></Site>} />
          <Route path="/leistungen/:slug" element={<Site light><ServiceDetail /></Site>} />
          <Route path="/anfrage/:slug" element={<Site light><Configurator /></Site>} />
          <Route path="/leistungen/:slug/:ort" element={<Site light><LeistungOrt /></Site>} />
          <Route path="/einsatzgebiete" element={<Site light><Einsatzgebiete /></Site>} />
          <Route path="/einsatzgebiete/:ort" element={<Site light><OrtPage /></Site>} />
          <Route path="/besichtigung" element={<Site light><Besichtigung /></Site>} />
          <Route path="/kontakt" element={<Site light><Kontakt /></Site>} />
          <Route path="/impressum" element={<Site light><Impressum /></Site>} />
          <Route path="/datenschutz" element={<Site light><Datenschutz /></Site>} />
          <Route path="/admin/login" element={<Suspense fallback={<Loading />}><AdminLogin /></Suspense>} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Suspense fallback={<Loading />}>
                  <AdminDashboard />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Site light><NotFound /></Site>} />
        </Routes>
        </SeoProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
